import { Component } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { GigyaService } from '../../../services/gigya.service';
import { OrganizationPickerService } from '../../../services/organization-picker.service';
import { InputComponent } from '../../../shared/input/input.component';
import { SpinnerComponent } from '../../../shared/icons/spinner/spinner.component';
import { ButtonComponent } from '../../../shared/button/button.component';
import { WarningIconComponent } from '../../../shared/icons/warning/warning.component';

@Component({
  selector: 'app-mfa-authenticator',
  standalone: true,
  imports: [RouterLink, TranslatePipe, ReactiveFormsModule, InputComponent, SpinnerComponent, ButtonComponent, WarningIconComponent],
  templateUrl: './mfa-authenticator.component.html',
  styleUrl: './mfa-authenticator.component.css'
})
export class MfaAuthenticatorComponent {
  public failed = false
  public loading = false;
  public resendLoading = false;
  public form:FormGroup = new FormGroup({
    code: new FormControl(""),
    remember: new FormControl(false)
  })

  constructor(
    private gigyaService: GigyaService,
    private organizationPicker: OrganizationPickerService
  ) {}

  public onSubmit(): void {
    this.loading = true;

    window.setTimeout(() => {
      this.loading = false;
      if (this.failed) {
        this.organizationPicker.proceed();
        return;
      }
      this.failed = true;
      this.form.controls['code'].setErrors({'incorrect': true});
    }, 1000);
  }
}
